import { render, staticRenderFns } from "./PaymentShopeePay.vue?vue&type=template&id=6b06e66a&scoped=true"
import script from "./PaymentShopeePay.vue?vue&type=script&lang=js"
export * from "./PaymentShopeePay.vue?vue&type=script&lang=js"
import style0 from "./PaymentShopeePay.vue?vue&type=style&index=0&id=6b06e66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06e66a",
  null
  
)

export default component.exports